<template>
  <div>
    <van-popup v-model="showBackInfo" :style="{ width: '75%' }">
      <van-field
        v-model="backInfo"
        rows="6"
        autosize
        label=""
        type="textarea"
        maxlength="50"
        class="long-label2"
        show-word-limit
      >
        <template #label>
          <div style="line-height: 0.5rem">退回<br>原因</div>
          <div class="xx-box" @click="handOpenXX" >选项</div>
        </template>
      </van-field>
      <div class="bottom" style="position: relative">
        <div style="display:flex;box-shadow: rgba(0, 0, 0, 0.1) 0px -1px 10px;height: 100%;align-items: center;">
          <div offset="1" style="text-align: center;flex: 1; position: relative;">
            <v-button class="btn1" @click="closeBackInfo()">取消</v-button>
          </div>
          <div offset="1" style="text-align: center;flex: 1; position: relative;">
          <v-button class="btn1 btn2" @click="saveBackInfo()">保存</v-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 说明原因弹窗 -->
    <van-popup v-model="showReason" position="bottom" round closeable :style="{ height: '40%' }" >
        <van-sticky>
            <div class="reasonTitle">请选择退回原因</div>
        </van-sticky>
        <div class="reason-box">
            <div class="reason-item" v-for="(item, index) in reasonList" :key="index" @click="handreasonSure(item)">{{ item.name }}
            <van-icon name="success" color="#0052D9"  size="0.45rem" v-if="item.checked" />
            </div>
        </div>
    </van-popup>
  </div>
</template>
<script>
import { listCodeItemBatch2 } from "@/api/baseMsg";
export default {
    props: {
      showBackInfo: {
        type: Boolean,
        default: false
      },
      backInfoTwo: {
        type: String,
        default: ''
      }
    },
    data() {
        return {
            showDetial: false,
            showReason: false,
            reasonList: [],
            backInfo: ''
        }
    },
    watch: {
      showBackInfo(newVal) {
        if(newVal) {
          this.backInfo = this.backInfoTwo
        }
      },
    },
    created() {
        this.getReasonList()
    },
    methods: {
      closeBackInfo() {
        this.$emit('close')
      },
      saveBackInfo() {
        this.$emit('confirm', this.backInfo)
      },
      // 处理数据
      initData(item) {
          
      },


        // 选项
        getReasonList() {
            listCodeItemBatch2({dmgrp: 'code_ReturnReasons'}).then(res=> {
                if(res.code == 200) {
                res.data.forEach(i=> {
                    i.checked = false
                })
                this.reasonList = res.data
                }else {
                this.reasonList = []
                }
            })
        },
        handOpenXX() {
            this.reasonList.forEach(i=> {
                i.checked = false
                if(this.backInfo.indexOf(i.name) > -1) {
                  i.checked = true
                }
            })
            this.showReason = true
        },
        handreasonSure(row) {
            this.reasonList.forEach(i=> {
              if(i.id == row.id) {
                i.checked = !i.checked
              }
            })
            let text = "";
            let val = row.name
            if (this.backInfo) {
                // while (String(this.content).indexOf('，') > -1) {
                //   this.content = String(this.content).replace('，', ',')
                // }
                text = String(this.backInfo);
            }
            // 一个是累加到 input框中、
            if (text.indexOf(val) > -1) {
                if (text.length === val.length) {
                this.backInfo = "";
                } else {
                /**
                 * 这里判断输入框中 存在快捷选项进入判断
                 * 判断点击的快捷选项往前一个字符和往后一个字符包不包含,号
                 * 过滤：
                 * 若快捷选项从0开始，有一个,号
                 * 若快捷选项在中间，必须有两个,号
                 *
                 * 替换：
                 * 其他情况就只替换快捷选项为空即可
                 */
                const start = text.indexOf(val);
                // console.log('索引值', Number(start) + Number(val.length), text.length)
                const valStr = text.substring(
                    Number(start) - 1,
                    Number(start) + Number(val.length) + 1
                );
                const valStrTwo = valStr.split("、").length - 1;
                if (
                    (Number(start) === 0 && valStr.indexOf("、") > -1) ||
                    Number(valStrTwo) === 2 ||
                    (Number(start) + Number(val.length) === text.length &&
                    valStr.indexOf("、") > -1)
                ) {
                    this.backInfo = text
                    .split("、")
                    .filter(item => item !== val)
                    .join("、");
                } else {
                    this.backInfo = text.replace(val, "");
                }
                }
            } else {
                if (text.length > 0) {
                this.backInfo = text + `、${val}`;
                } else {
                this.backInfo = val;
                }
            }
        },
    }
}
</script>
<style lang="scss" scoped>

.long-label2 {
  /deep/.van-field__label {
    align-items: center;
    display: flex;
    width: 1.2rem !important;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
    .xx-box {
      border-radius: 2px;
      background: #E8F3FF;
      border: 1px solid #E8F3FF;
      color: #498DFE;
      font-size: px2rem(36);
      text-align: center;
      width: 100%;
      height: 0.5rem;
      line-height: 0.5rem;
      margin-top: 0.5rem;

    }
}
.bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    background-color: #fff;
    .btn1 {
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      font-size: px2rem(45);
      color: #2c7fe2;
      font-weight: bold;
      font-family: "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
      width: 2rem;
      // border-right: 1px solid #ababab;
    }
    v-button.btn1::after {
        content: '';
        width: 0.02rem;
        height: 0.6rem;
        background: #ababab;
        position: absolute;
        right: 0;
    }
    v-button.btn2::after {
        content: '';
        width: 0rem;
        height: 0rem;
    }
  }
  .reasonTitle {
    padding: 0.4rem;
    color: #000000E5;
    font-family: PingFang SC;
    font-size: px2rem(38);
    text-align: left;
    font-weight: bold;
  }
  .reason-box {
    .reason-item {
      font-size: px2rem(36);
      text-align: left;
      padding: 0.4rem;
      color: #333333;
      border-bottom: 1px solid #f1f1f1;
      display: flex;
      justify-content: space-between;
      .dui-icon {
        color: #0052D9;
      }
    }
  }
  
  
</style>